import { render, staticRenderFns } from "./BuyMealRecord.vue?vue&type=template&id=55dd7d45&scoped=true&"
import script from "./BuyMealRecord.vue?vue&type=script&lang=js&"
export * from "./BuyMealRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd7d45",
  null
  
)

export default component.exports